import HttpClient from './HttpClient'

export async function fetchExamStatus(slug) {
  const { data } = await HttpClient().get(`/api/v1/characters/${slug}/academy/exam`)
  return data?.data ?? data
}

export async function requestExam(slug) {
  const { data } = await HttpClient().post(`/api/v1/characters/${slug}/academy/exam/request`)
  return data?.data ?? data
}

export async function cancelExam(slug) {
  const { data } = await HttpClient().post(`/api/v1/characters/${slug}/academy/exam/cancel`)
  return data?.data ?? data
}

export async function fetchSenseis() {
  const { data } = await HttpClient().get('/api/v1/academy/senseis')
  return data?.data ?? data ?? []
}

export async function fetchExamQueue() {
  const { data } = await HttpClient().get('/api/v1/admin/academy/exam/queue')
  return data?.data ?? data ?? []
}

/** Pool staff (evento / sensei). Preferir ruta academy (staff role o permiso exam). */
export async function fetchStaffCharacters() {
  try {
    const { data } = await HttpClient().get('/api/v1/academy/staff-characters')
    return data?.data ?? data ?? []
  } catch {
    const { data } = await HttpClient().get('/api/v1/admin/academy/staff-characters')
    return data?.data ?? data ?? []
  }
}

export async function closeExam(characterId, { asCharacterId } = {}) {
  const { data } = await HttpClient().post(`/api/v1/admin/academy/exam/${characterId}/close`, {
    asCharacterId: asCharacterId ?? null,
  })
  return data?.data ?? data
}

export async function patchExamFlags(characterId, flags) {
  const { data } = await HttpClient().patch(`/api/v1/admin/academy/exam/${characterId}/flags`, flags)
  return data?.data ?? data
}

export async function assignSensei(characterId, senseiCharacterId) {
  const { data } = await HttpClient().patch(
    `/api/v1/admin/academy/exam/${characterId}/assign-sensei`,
    { senseiCharacterId }
  )
  return data?.data ?? data
}

export async function setStaffFlags(characterId, flags) {
  const { data } = await HttpClient().patch(
    `/api/v1/admin/academy/characters/${characterId}/staff-flags`,
    flags
  )
  return data?.data ?? data
}
